import React, { useState, useRef, useEffect } from "react";
import { Redirect } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/images/fflogo.svg";
import { Link } from 'react-router-dom'
import QuickFindSearchbar from "./QuickFindSearchbar";
import IconButton from "./IconButton";
import notificationIcon from "../../assets/images/notificationIcon.svg"
import moon from "../../assets/images/moon.svg"
import { Languages, Bell } from "lucide-react";
import { setLanguage, getCurrentLanguage } from "../../locales/translate";
import NotificationPanel from "./NotificationPanel";
import { useSelector } from "react-redux";

const Header = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const unreadCount = useSelector((state) => state.notificationsReducer.unreadCount);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const currentLang = getCurrentLanguage();
  const isRTL = currentLang === "ar-SA" || currentLang === "ur-PK";
  const languages = [
    { code: 'en-US', label: 'English' },
    { code: 'ur-PK', label: 'اردو' },
    { code: 'ar-SA', label: 'العربية' }
  ];

    const handleLanguageChange = (code) => {
    setLanguage(code);
    setLangDropdownOpen(false);
  };

  const [notificationOpen, setNotificationOpen] = useState(false);
  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLangDropdownOpen(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotificationOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  return (
    <>
      {user.status ? (
        <div className="bg-12 d-flex align-items-center justify-content-between">
          <div className="pl-4 header-logo">
            <a className="navbar-brand" href="#">
              <img src={logo} alt="Logo" style={{ width: "220px", height: "32px" }} />
            </a>
          </div>
          <div  style={{position: 'absolute',left: '50%',transform: 'translateX(-50%)',zIndex: 9999}}>
            <QuickFindSearchbar />
          </div>
          <div className={`d-flex align-items-center gap-4 ${isRTL ? "mr-auto ml-2" : "ml-auto mr-2"}`}>
            <div ref={dropdownRef} className="position-relative lang-btn-wrapper">
              <IconButton
                iconElement={Languages}
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
              />
              {langDropdownOpen && (
                <div className="lang-dropdown">
                  {languages.map(({ code, label }) => (
                    <div
                      key={code}
                      className={`lang-option ${currentLang === code ? "active" : ""}`}
                      onClick={() => handleLanguageChange(code)}
                    >
                      {label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div ref={notificationRef} className="position-relative">
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <IconButton
                  iconElement={Bell}
                  onClick={() => setNotificationOpen(!notificationOpen)}
                />
                {unreadCount > 0 && (
                  <span className="notif-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                )}
              </div>
              {notificationOpen && <NotificationPanel onClose={() => setNotificationOpen(false)} />}
            </div>
          </div>
          
          <Link className="float-right mr-4" to={{ pathname: "/admin/Profile" }}>
            <div
              className="header-avatar-wrapper"
              style={{ display: "flex", gap: "12px", alignItems: "center" }}
            >
              <div style={{ height: "40px", width: "40px" }}>
                <p>
                  {user.result[0].user.firstName.charAt(0)}
                  {user.result[0].user.lastName.charAt(0)}
                </p>
              </div>
              <span >
                <p className="name_font">
                  {user.result[0].user.firstName +
                    " " +
                    user.result[0].user.lastName}
                </p>
                <p className=" designation_font">{user.result[0].user.designation}</p>
              </span>
            </div>
          </Link>
        </div>
      ) : (
        <>
          <Redirect to="/" />
        </>
      )}
    </>
  );
};

export default Header;
